import gql from 'graphql-tag';

import dokkioObjectDokkioTagFragment from './dokkioObjectDokkioTagFragment';
import embeddedDokkioTagFragment from './embeddedDokkioTagFragment';
import taskFragment from './taskFragment';

export const dokkioTagFragment = gql`
  fragment dokkioTagFragment on DokkioTag {
    ...embeddedDokkioTagFragment
    taggedObjectCount
    newObjectCount
    suggestionCount
    integrationID
    dokkioObjectDokkioTags {
      ...dokkioObjectDokkioTagFragment
    }
    dokkioTags {
      ...embeddedDokkioTagFragment
    }
    tasks {
      ...taskFragment
    }
  }
  ${dokkioObjectDokkioTagFragment}
  ${embeddedDokkioTagFragment}
  ${taskFragment}
`;
export default dokkioTagFragment;
